<template>
  <div id="app" v-bind:class="`${vista} in-iframe-${inIframe}`">
    <top-bar></top-bar>
    <div class="router-container">
      <wrap-container class="w100 router-container-inner">
        <router-view />
      </wrap-container>
      <app-footer v-if="!loading && footerText" :text="footerText"></app-footer>
      <app-footer-planes
        v-if="!loading && footerPlanesText"
        :text="footerPlanesText"
      ></app-footer-planes>
      <app-footer-seguros
        v-if="!loading && footerSegurosText"
        :text="footerSegurosText"
      ></app-footer-seguros>
    </div>
    <lottie-loader v-if="loading" />
    <notification-toast />
    <notification-modal />
  </div>
</template>

<script>
import AppFooter from "@/components/core/AppFooter";
import AppFooterPlanes from "./components/core/AppFooterPlanes.vue";
import WrapContainer from "@/components/core/Container";
import TopBar from "@/components/core/TopBar";
import NotificationToast from "@/components/core/NotificationToast";
import NotificationModal from "@/components/core/NotificationModal";
import LottieLoader from "@/components/core/LottieLoader";
import _get from "lodash/get";
import AppFooterSeguros from "./components/core/AppFooterSeguros.vue";

export default {
  name: "App",
  components: {
    TopBar,
    AppFooter,
    AppFooterPlanes,
    LottieLoader,
    WrapContainer,
    NotificationToast,
    AppFooterSeguros,
    NotificationModal
  },
  data() {
    return {
      vista: null,
      inIframe: window.top !== window.self
    };
  },
  computed: {
    loading() {
      return this.$store.state.isLoading;
    },
    footerText() {
      let pasoFooter = this.config.pasos[this.vista]
        ? this.config.pasos[this.vista].footerText
        : null;
      if (pasoFooter === null) {
        return null;
      }
      let footerText = pasoFooter || _get(this.config, "footerText", null);
      return footerText;
    },
    footerSegurosText() {
      let pasoFooterSeguros = this.config.pasos[this.vista]
        ? this.config.pasos[this.vista].footerSegurosText
        : null;
      if (pasoFooterSeguros === null) {
        return null;
      }
      let footerSegurosText =
        pasoFooterSeguros || _get(this.config, "footerSegurosText", null);
      return footerSegurosText;
    },
    footerPlanesText() {
      let pasoFooterPlanes = this.config.pasos[this.vista]
        ? this.config.pasos[this.vista].footerPlanesText
        : null;
      if (pasoFooterPlanes === null) {
        return null;
      }
      let footerPlanesText =
        pasoFooterPlanes || _get(this.config, "footerPlanesText", null);
      return footerPlanesText;
    }
  },

  mounted() {
    this.$store.watch(
      this.$store.getters.getRoute,
      route => {
        // Obtengo el name de la vista para agregar clase general al div#app
        this.vista = route.name;
      },
      { immediate: true }
    );
  }
};
</script>

<style>
#app {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  margin: auto;
}

.router-container {
  padding-top: 90px;
  padding-left: 17px;
  padding-right: 17px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.in-iframe-true .router-container {
  padding-top: 0 !important;
}

/* Estilos globales para cada paso usando la clase con el nombre de la ruta */
#app.gracias {
  background: #043263;
  /* HACK: Problema con overflow por no poder
  dar color de fondo al body
  doy scroll al elemento #app */
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
#app.gracias.in-iframe-true {
  position: relative !important;
}

@media screen and (min-width: 600px) {
  .router-container {
    /*El padding debe incluir la top bar + padding de contenedor y dar una distancia de 60 px
    entre el topbar y el primer título
    padding = altura top bar - 17px + 60px;
    */
    padding-top: 103px;
  }
}
</style>
